<div class="content-wrapper container-xxl p-0">
  <div class="content-body">
    <app-content-header [contentHeader]="contentHeader"></app-content-header>
    <div id="page-accordion">
      <!-- masterdata -->
      <div class="card" [ngClass]="activeTab === 'masterdata' ? 'active' : ''" [formGroup]="formGroup">
        <div class="card-title px-2 mb-0" (click)="changeTab('masterdata')">
          <h4 class="mb-0">{{ "MASTERDATA" | translate }}</h4>
        </div>
        <section [ngClass]="activeTab === 'masterdata' ? 'card-body' : ''" class="row">
          <div class="form-group col-xl-5 col-md-6 col-12">
            <label for="firstname">{{ "FIRSTNAME" | translate }}<sup class="text-danger">*</sup></label>
            <input type="text" id="firstname" class="form-control {{ fieldHasErrors('firstname') ? 'is-invalid' : '' }}" [formControlName]="'firstname'" />
            <div class="invalid-feedback" *ngIf="formGroup.controls.firstname.errors?.required">{{ "ERRORS.INSERT_NAME" | translate }}</div>
            <div class="invalid-feedback" *ngIf="formGroup.controls?.firstname?.errors?.minlength">{{ "MIN" | translate }} 2 {{ "CHARACTERS" | translate }}</div>
            <div class="invalid-feedback" *ngIf="formGroup.controls?.firstname?.errors?.maxlength">{{ "MAX" | translate }} 255 {{ "CHARACTERS" | translate }}</div>
          </div>
          <div class="form-group col-xl-5 col-md-6 col-12">
            <label for="lastname">{{ "LASTNAME" | translate }}<sup class="text-danger">*</sup></label>
            <input type="text" id="lastname" class="form-control {{ fieldHasErrors('lastname') ? 'is-invalid' : '' }}" [formControlName]="'lastname'" />
            <div class="invalid-feedback" *ngIf="formGroup.controls.lastname.errors?.required">{{ "ERRORS.INSERT_LASTNAME" | translate }}</div>
            <div class="invalid-feedback" *ngIf="formGroup.controls?.lastname?.errors?.minlength">{{ "MIN" | translate }} 2 {{ "CHARACTERS" | translate }}</div>
            <div class="invalid-feedback" *ngIf="formGroup.controls?.lastname?.errors?.maxlength">{{ "MAX" | translate }} 255 {{ "CHARACTERS" | translate }}</div>
          </div>
          <div class="form-group col-xl-2 col-md-6 col-12">
            <label for="sex">{{ "GENDER" | translate }}</label>
            <select name="sex" id="sex" class="form-control {{ fieldHasErrors('sex') ? 'is-invalid' : '' }}" [formControlName]="'sex'">
              <option [value]="null" selected disabled>{{ "ERRORS.SELECT_GENDER" | translate }}</option>
              <option value="m">{{ "MALE" | translate }}</option>
              <option value="f">{{ "FEMALE" | translate }}</option>
              <option value="o">{{ "OTHER" | translate }}</option>
            </select>
            <div class="invalid-feedback" *ngIf="formGroup.controls.sex.errors?.required">{{ "ERRRORS.INSERT_SEX" | translate }}</div>
          </div>
          <div class="form-group col-xl-3 col-md-6 col-12">
            <label for="email">{{ "PRIVATE_EMAIL" | translate }}<sup class="text-danger">*</sup></label>
            <input type="text" id="email" class="form-control {{ fieldHasErrors('email') ? 'is-invalid' : '' }}" [formControlName]="'email'" />
            <div class="invalid-feedback" *ngIf="formGroup.controls.email.errors?.required">{{ "ERRORS.INSERT_PRIVATE_EMAIL" | translate }}</div>
          </div>
          <div class="form-group col-xl-3 col-md-4 col-12">
            <label for="phone">{{ "PRIVATE_PHONE" | translate }}<sup class="text-danger">*</sup></label>
            <input type="tel" id="phone" maxlength="15" class="form-control {{ fieldHasErrors('phone') ? 'is-invalid' : '' }}" [formControlName]="'phone'" />
            <div class="invalid-feedback" *ngIf="formGroup.controls.phone.errors?.required">{{ "ERRORS.INSERT_PRIVATE_PHONE" | translate }}</div>
            <div class="invalid-feedback" *ngIf="formGroup.controls?.phone?.errors?.minlength">{{ "MIN" | translate }} 9 {{ "CHARACTERS" | translate }}</div>
            <div class="invalid-feedback" *ngIf="formGroup.controls?.phone?.errors?.maxlength">{{ "MAX" | translate }} 15 {{ "CHARACTERS" | translate }}</div>
          </div>
          <div class="form-group col-xl-3 col-md-4 col-12">
            <label for="working_city">{{ "WORKING_CITY" | translate }}<sup class="text-danger">*</sup></label>
            <ng-select
              [formControlName]="'working_city'"
              id="working_city"
              bindLabel="nice_name"
              bindValue="id"
              [searchable]="true"
              [closeOnSelect]="true"
              [clearable]="true"
              placeholder="{{ 'ERRORS.SELECT_CITY' | translate }}"
              [items]="_citiesService.list"
              [openOnEnter]="false"
              [virtualScroll]="true"
              class="{{ fieldHasErrors('working_city') ? 'is-invalid' : '' }}"
            >
            </ng-select>
            <div class="invalid-feedback" *ngIf="formGroup.controls.working_city.errors?.required">{{ "ERRORS.INSERT_WORKING_CITY" | translate }}</div>
          </div>
          <div class="form-group col-xl-3 col-md-4 col-12">
            <label for="birthday">{{ "BIRTHDAY" | translate }}</label>
            <input type="date" id="birthday" class="form-control" [max]="eighteen_years_ago" [formControlName]="'birthday'" />
          </div>
          <div class="col-12 border-top pt-1 mt-1"></div>
          <div class="form-group col-xl-3 col-12">
            <fieldset>
              <label for="fileCurriculum">{{ "TITLES.CURRICULUM" | translate }}</label>
              <div class="custom-file">
                <input class="custom-file-input" type="file" lang="it" id="fileCurriculum" accept="application/pdf" (change)="handlerChangeFileInput($event)" />
                <label *ngIf="!fileName" class="custom-file-label">{{ "MAX_FILE" | translate }}</label>
                <label *ngIf="fileName && fileName.length > 0" class="custom-file-label">{{ fileName }}</label>
              </div>
            </fieldset>
            <a *ngIf="fileErrorSize" class="text-underline text-primary" target="_blank" href="https://pdfcompressor.com/it/">{{ "CLICK_HERE_COMPRESS_FILE" | translate }}</a>
            <div *ngIf="currentUser && !!currentUser.cv_url">
              <button class="bg-transparent border-0 font-small-3 mt-075 d-block w-fit text-primary" (click)="_utilService.getFile(currentUser.cv_url)" type="button">{{ "VIEW_CANDIDATE_CURRICULUM" | translate }}</button>
            </div>
          </div>
          <div class="form-group col-xl-3 col-md-6 col-12">
            <label for="figure">{{ "PROFESSIONAL_FIGURE" | translate }}<sup class="text-danger">*</sup></label>
            <ng-select
              bindValue="id"
              bindLabel="name"
              id="figure"
              class="{{ fieldHasErrors('figure') ? 'is-invalid' : '' }}"
              [formControlName]="'figure'"
              [items]="_userFigureService.list"
              [closeOnSelect]="true"
              [clearable]="false"
              [openOnEnter]="false"
              [virtualScroll]="true"
              (change)="_manageContractService.data.role = formGroup.value.figure"
            >
            </ng-select>
            <div class="invalid-feedback" *ngIf="formGroup.controls.figure.errors?.required">
              {{ "ERRORS.FIELD_FIGURE_PROFESSIONAL" | translate }}
            </div>
          </div>
          <div class="form-group col-xl-3 col-md-6 col-12">
            <label for="source_id">{{ "SOURCE" | translate }}</label>
            <ng-select
              bindValue="id"
              bindLabel="name"
              id="source_id"
              [formControlName]="'source_id'"
              [items]="sourcesList"
              [closeOnSelect]="true"
              [clearable]="false"
              [openOnEnter]="false"
              [virtualScroll]="true"
            ></ng-select>
          </div>
          <div class="form-group col-xl-3 col-md-6 col-12" *ngIf="currentUser && currentUser.creator">
            <label for="creator_id">{{ "INSERTED_BY" | translate }}</label>
            <input type="text" id="creator_id" class="form-control" readonly [value]="currentUser.creator.complete_name" />
          </div>
          <div class="form-group col-xl-3 col-md-6 col-12">
            <label for="judgment" class="mb-0">{{ "RATING" | translate }}</label>
            <ng-select
              bindValue="id"
              bindLabel="name"
              id="judgment"
              [formControlName]="'judgment'"
              [items]="candidateRatingsList"
              [closeOnSelect]="true"
              [clearable]="false"
              [openOnEnter]="false"
              [virtualScroll]="true"
            ></ng-select>
          </div>
        </section>
      </div>
      <!-- contract -->
      <div class="card" [ngClass]="activeTab === 'contract' ? 'active' : ''">
        <div class="card-title px-2 mb-0" (click)="changeTab('contract')">
          <h4 class="mb-0">{{ "CONTRACT" | translate }}</h4>
        </div>
        <section id="contract-section" [ngClass]="activeTab === 'contract' ? 'card-body' : ''">
          <!-- CONTRATTO CORRENTE -->
          <div class="row" [formGroup]="formGroup">
            <h5 class="col-12 mb-1">{{ "CURRENT_CONTRACT" | translate }}</h5>
            <div class="form-group col-xl-4 col-12">
              <label for="current_contract_type">{{ "CONTRACT_TYPE" | translate }}</label>
              <ng-select
                [items]="_contractService.listWithVat"
                [closeOnSelect]="true"
                [clearable]="false"
                id="current_contract_type"
                (change)="resetCurrentContract($event); contract_is_changed = true"
                [formControlName]="'current_contract_type'"
                placeholder="{{ 'ERRORS.SELECT_CONTRACT' | translate }}"
                bindLabel="name"
                bindValue="id"
              >
              </ng-select>
            </div>
            <div class="form-group col-xl-4 col-md-6 col-12" *ngIf="currentContractSelected !== 'Stage' && currentContractSelected !== 'Disoccupato' && currentContractSelected !== 'Partita IVA'">
              <label for="current_contract_ral">{{ "SALARY_YEARLY_GROSS" | translate }}</label>
              <div class="input-group input-group-merge">
                <div class="input-group-prepend">
                  <span class="input-group-text">&euro;</span>
                </div>
                <input type="text" id="current_contract_ral" [formControlName]="'current_contract_ral'" class="form-control" (change)="formatCurrentRal(); contract_is_changed = true" />
              </div>
            </div>
            <div class="form-group col-xl-4 col-md-6 col-12" *ngIf="currentContractSelected !== 'Disoccupato'">
              <label *ngIf="currentContractSelected !== 'Partita IVA'" for="current_contract_net_monthly">{{ "NET_MONTHLY_12" | translate }}</label>
              <label *ngIf="currentContractSelected === 'Partita IVA'">{{ "COST_DAILY" | translate }}</label>
              <div class="input-group input-group-merge">
                <div class="input-group-prepend">
                  <span class="input-group-text">&euro;</span>
                </div>
                <input type="text" id="current_contract_net_monthly" [formControlName]="'current_contract_net_monthly'" class="form-control" (change)="formatCurrentNetMonthly(); contract_is_changed = true" />
              </div>
            </div>
            <div class="form-group col-xl-4 col-md-6 col-12">
              <label for="notice_resignation">{{ "NOTICE" | translate }}</label>
              <ng-select (change)="contract_is_changed = true" [closeOnSelect]="true" [clearable]="false" id="notice_resignation" [formControlName]="'notice_resignation'" placeholder="{{ 'SELECT_NOTICE_RESIGNATION' | translate }}">
                <ng-option *ngFor="let n of notice_times" [value]="n.days">{{ n.label }}</ng-option>
              </ng-select>
            </div>
            <div class="form-group col-xl-4 col-md-6 col-12" *ngIf="currentContractSelected !== 'Stage' && currentContractSelected !== 'Disoccupato' && currentContractSelected !== 'Partita IVA'">
              <label for="current_contract_bonus">{{ "MONTHLY_BONUSES" | translate }}</label>
              <div class="input-group input-group-merge">
                <div class="input-group-prepend">
                  <span class="input-group-text">&euro;</span>
                </div>
                <input type="text" id="current_contract_bonus" class="form-control bg-white" [formControlName]="'current_contract_bonus'" (change)="formatCurrentBonusMonthly(); contract_is_changed = true" />
              </div>
            </div>
            <div class="form-group col-xl-4 col-md-6 col-12" *ngIf="currentContractSelected !== 'Stage' && currentContractSelected !== 'Disoccupato' && currentContractSelected !== 'Partita IVA'">
              <label for="current_contract_ticket">{{ "TICKET_TOTAL_MONTH" | translate }}</label>
              <div class="input-group input-group-merge">
                <div class="input-group-prepend">
                  <span class="input-group-text">&euro;</span>
                </div>
                <input type="text" id="current_contract_ticket" class="form-control bg-white" (change)="formatCurrentTicketTotal(); contract_is_changed = true" [formControlName]="'current_contract_ticket'" />
              </div>
            </div>
            <div class="form-group col-xl-4 col-md-4 col-12" *ngIf="currentContractSelected !== 'Disoccupato'">
              <label for="ccnl">{{ "CCNL" | translate }}</label>
              <input class="form-control" id="ccnl" type="text" maxlength="255" (change)="contract_is_changed = true" [formControlName]="'current_ccnl'" placeholder="{{ 'ERRORS.SELECT_CCNL' | translate }}" />
            </div>
            <div class="form-group col-xl-4} col-md-4 col-12">
              <label for="site">{{ "JOB_SITE" | translate }}</label>
              <ng-select
                bindValue="id"
                bindLabel="name"
                id="site"
                (change)="contract_is_changed = true"
                [formControlName]="'site'"
                [items]="_jobSiteService.list"
                placeholder="{{ 'ERRORS.SELECT_JOB_SITE' | translate }}"
                [closeOnSelect]="true"
                [clearable]="false"
                [openOnEnter]="false"
                [virtualScroll]="true"
              >
              </ng-select>
            </div>
            <div class="form-group col-xl-4 col-md-4 col-12" *ngIf="currentContractSelected !== 'Disoccupato'">
              <label for="current_program">{{ "CONTRACT_PROGRAM" | translate }}<sup class="text-danger">*</sup></label>
              <ng-select
                id="current_program"
                [items]="_contractService.programs"
                bindLabel="label"
                bindValue="value"
                [closeOnSelect]="true"
                [clearable]="true"
                formControlName="current_program"
                (change)="contract_is_changed = true"
              >
              </ng-select>
            </div>
          </div>

          <!-- CONTRATTO DESIDERATO -->
          <div class="row border-top mt-2 pt-2">
            <h5 class="col-12 mb-1">{{ "DESIRED_CONTRACT" | translate }}</h5>
            <div class="form-group col-md-6 col-xl-6 col-12">
              <label for="contract_id">{{ "CONTRACT_TYPE" | translate }}<sup class="text-danger">*</sup></label>
              <ng-select
                id="contract_id"
                [items]="_contractService.listWithVat"
                bindLabel="name"
                bindValue="id"
                [closeOnSelect]="true"
                [clearable]="false"
                [(ngModel)]="_manageContractService.data.contract"
                class="{{ !_manageContractService.data.contract ? 'is-invalid' : '' }}"
                (change)="_manageContractService.changeContract($event); contract_is_changed = true"
                placeholder="{{ 'ERRORS.SELECT_CONTRACT' | translate }}"
              ></ng-select>
              <div class="invalid-feedback" *ngIf="!_manageContractService.data.contract">{{ "ERRORS.INSERT_TYPE_CONTRACT" | translate }}</div>
            </div>

            <!-- livello -->
            <div class="form-group col-xl-6 col-md-6 col-12" *ngIf="!_manageContractService.typeIsStage && !_manageContractService.typeIsVatNumber">
              <label for="contract_level">{{ "LEVEL" | translate }}<sup class="text-danger">*</sup></label>
              <ng-select
                *ngIf="_manageContractService.levels_for_select.length > 0"
                id="contract_level"
                [(ngModel)]="_manageContractService.data.level"
                [closeOnSelect]="true"
                [clearable]="false"
                [openOnEnter]="false"
                [virtualScroll]="true"
                (change)="_manageContractService.changeLevel(true); contract_is_changed = true"
                class="{{ !_manageContractService.data.level ? 'is-invalid' : '' }}"
              >
                <ng-option *ngFor="let lvl of _manageContractService.levels_for_select" [value]="lvl">{{ lvl }}</ng-option>
              </ng-select>
              <select *ngIf="_manageContractService.levels_for_select.length < 1" disabled class="form-control"></select>
              <div class="invalid-feedback" *ngIf="!_manageContractService.data.level">{{ "ERRORS.INSERT_LEVEL" | translate }}</div>
            </div>
            <!-- RAL-->
            <div class="form-group col-xl-4 col-md-6 col-12" *ngIf="!_manageContractService.typeIsStage && !_manageContractService.typeIsVatNumber">
              <label for="salary_yearly_gross">{{ "SALARY_YEARLY_GROSS" | translate }}<sup class="text-danger">*</sup></label>
              <div class="input-group input-group-merge {{ !_manageContractService.data.salary_yearly_gross && _manageContractService.data.contract ? 'is-invalid' : '' }}">
                <div class="input-group-prepend">
                  <span class="input-group-text" [ngClass]="_manageContractService.data.contract === null ? 'bg-readonly' : ''">&euro;</span>
                </div>
                <input
                  type="text"
                  id="salary_yearly_gross"
                  class="form-control {{ !_manageContractService.data.salary_yearly_gross && _manageContractService.data.contract ? 'is-invalid' : '' }}"
                  pattern="\d*"
                  [readonly]="!_manageContractService.data.contract"
                  [(ngModel)]="_manageContractService.data.salary_yearly_gross"
                  (change)="transformRal($any($event.target).value); contract_is_changed = true"
                />
              </div>
              <div class="invalid-feedback" *ngIf="!_manageContractService.data.salary_yearly_gross || _manageContractService.data.salary_yearly_gross.length < 1">{{ "ERRORS.INSERT_RAL" | translate }}</div>
            </div>
            <div class="form-group col-xl-4 col-md-6 col-12" *ngIf="!_manageContractService.typeIsStage && !_manageContractService.typeIsVatNumber">
              <label for="bonus">{{ "MONTHLY_BONUSES" | translate }}</label>
              <div class="input-group input-group-merge">
                <div class="input-group-prepend">
                  <span class="input-group-text" [ngClass]="!_manageContractService.data.contract ? 'bg-readonly' : ''">&euro;</span>
                </div>
                <input
                  type="text"
                  [readonly]="!_manageContractService.data.contract"
                  id="bonus"
                  pattern="\d*"
                  (change)="_manageContractService.updateData(); contract_is_changed = true"
                  class="form-control"
                  [(ngModel)]="_manageContractService.data.bonus"
                />
              </div>
            </div>
            <div class="form-group col-xl-4 col-md-6 col-12" *ngIf="!_manageContractService.typeIsStage && !_manageContractService.typeIsVatNumber">
              <label for="ticket_total">{{ "TICKET_TOTAL_MONTH" | translate }}</label>
              <div class="input-group input-group-merge">
                <div class="input-group-prepend">
                  <span class="input-group-text">&euro;</span>
                </div>
                <input type="text" pattern="\d*" class="form-control" id="ticket_total" (change)="_manageContractService.updateData(); contract_is_changed = true" [(ngModel)]="_manageContractService.data.ticket_total" />
              </div>
            </div>
            <div [class]="'form-group col-12 col-md-6 col-xl-' + (_manageContractService.typeIsStage || _manageContractService.typeIsVatNumber ? 6 : 4)">
              <label for="net_monthly_12"
              >{{ _manageContractService.typeIsStage ? ("SALARY_MONTH" | translate) : _manageContractService.typeIsVatNumber ? ("COST_DAILY" | translate) : ("SALARY_MONTH_12" | translate) }}
                <sup class="text-danger">*</sup></label
              >
              <div class="input-group input-group-merge" *ngIf="!_manageContractService.typeIsVatNumber">
                <div class="input-group-prepend">
                  <span class="input-group-text {{ !_manageContractService.typeIsStage && !_manageContractService.typeIsVatNumber ? 'bg-readonly' : '' }}">&euro;</span>
                </div>
                <input
                  type="text"
                  class="form-control"
                  id="net_monthly_12"
                  [readOnly]="!_manageContractService.typeIsStage && !_manageContractService.typeIsVatNumber"
                  pattern="\d*"
                  (change)="_manageContractService.updateData(); contract_is_changed = true"
                  [(ngModel)]="_manageContractService.data.net_monthly_12"
                />
              </div>
              <div class="input-group input-group-merge" *ngIf="_manageContractService.typeIsVatNumber">
                <div class="input-group-prepend">
                  <span class="input-group-text">&euro;</span>
                </div>
                <input type="text" class="form-control" id="total_daily" pattern="\d*" (change)="_manageContractService.updateData(); contract_is_changed = true" [(ngModel)]="_manageContractService.data.total_daily" />
              </div>
            </div>
            <div class="form-group col-xl-4 col-md-6 col-12" *ngIf="!_manageContractService.typeIsStage && !_manageContractService.typeIsVatNumber">
              <label for="net_monthly_13">{{ "SALARY_MONTH_13" | translate }}<sup class="text-danger">*</sup></label>
              <div class="input-group input-group-merge">
                <div class="input-group-prepend">
                  <span class="input-group-text bg-readonly">&euro;</span>
                </div>
                <input type="text" readonly="readonly" class="form-control" id="net_monthly_13" [(ngModel)]="_manageContractService.data.net_monthly_13" />
              </div>
            </div>
            <div class="form-group col-xl-4 col-md-6 col-12" *ngIf="!_manageContractService.typeIsStage && !_manageContractService.typeIsVatNumber">
              <label for="total_net_monthly_13">{{ "TOTAL_SALARY_MONTH_13" | translate }}<sup class="text-danger">*</sup></label>
              <div class="input-group input-group-merge">
                <div class="input-group-prepend">
                  <span class="input-group-text bg-readonly">&euro;</span>
                </div>
                <input type="text" readonly="readonly" class="form-control" id="total_net_monthly_13" [(ngModel)]="_manageContractService.data.total_net_monthly_13" />
              </div>
            </div>
          </div>
          <div class="row" [formGroup]="formGroup">
            <div class="form-group col-xl-4 col-md-4 col-12">
              <label for="contract_program">{{ "CONTRACT_PROGRAM" | translate }}<sup class="text-danger">*</sup></label>
              <ng-select
                id="contract_program"
                [items]="_contractService.programs"
                bindLabel="label"
                bindValue="value"
                [closeOnSelect]="true"
                [clearable]="true"
                (ngModelChange)="_manageContractService.updateData()"
                [ngModelOptions]="{ standalone: true }"
                [(ngModel)]="_manageContractService.data.program"
                (change)="contract_is_changed = true"
              >
              </ng-select>
            </div>
            <div class="form-group col-xl-4 col-md-4 col-12">
              <label for="desired_city">{{ "CITY" | translate }}<sup class="text-danger">*</sup></label>
              <ng-select
                [formControlName]="'desired_city'"
                id="desired_city"
                bindLabel="nice_name"
                bindValue="id"
                [searchable]="true"
                [closeOnSelect]="true"
                [clearable]="false"
                (change)="contract_is_changed = true"
                placeholder="{{ 'ERRORS.SELECT_CITY' | translate }}"
                [items]="_citiesService.list"
                [openOnEnter]="false"
                [virtualScroll]="true"
                class="{{ formGroup.value.desired_city ? '' : 'is-invalid' }}"
              >
              </ng-select>
              <div class="invalid-feedback" *ngIf="!formGroup.value.desired_city || formGroup.value.desired_city.length < 1">{{ "ERRORS.INSERT_ONE_CITY" | translate }}</div>
            </div>
            <!--Modalità di lavoro-->
            <div class="form-group col-xl-4 col-md-4 col-12">
              <label for="desired_site">{{ "JOB_SITE" | translate }}<sup class="text-danger">*</sup></label>
              <ng-select
                bindValue="id"
                bindLabel="name"
                required
                id="desired_site"
                [formControlName]="'desired_site'"
                [items]="_jobSiteService.list"
                placeholder="{{ 'ERRORS.SELECT_JOB_SITE' | translate }}"
                [closeOnSelect]="true"
                [clearable]="false"
                (change)="contract_is_changed = true"
                [openOnEnter]="false"
                [virtualScroll]="true"
                class="{{ formGroup.value.desired_site ? '' : 'is-invalid' }}"
              >
              </ng-select>
              <div class="invalid-feedback" *ngIf="!formGroup.value.desired_site || formGroup.value.desired_site.length < 1">{{ "ERRORS.INSERT_DESIRED_SITE" | translate }}</div>
            </div>
          </div>
          <div class="row border-top pt-2 mt-1" has_capability="candidate_view_costs">
            <div class="col-12" id="contract-daily-cost">
              {{ "TOTAL_SALARY_DAILY" | translate }}
              <strong>&euro; {{ _manageContractService.data.total_daily }}</strong>
            </div>
          </div>
        </section>
      </div>
      <!-- education -->
      <div class="card" [ngClass]="activeTab === 'education' ? 'active' : ''" [formGroup]="formGroup">
        <div class="card-title px-2 mb-0" (click)="changeTab('education')">
          <h4 class="mb-0">{{ "EDUCATION" | translate }}</h4>
        </div>
        <section [ngClass]="activeTab === 'education' ? 'card-body' : ''" class="row">
          <div class="form-group col-xl-4 col-md-6 col-12">
            <label for="education_title">{{ "EDUCATION_TITLE" | translate }}</label>
            <ng-select
              (change)="formGroup.patchValue({ education_subject: '' }); selectEducation()"
              bindValue="id"
              bindLabel="name"
              id="education_title"
              [formControlName]="'education_title'"
              [items]="_educationTitleService.list"
              [closeOnSelect]="true"
              [clearable]="false"
              [openOnEnter]="false"
              [virtualScroll]="true"
            ></ng-select>
          </div>
          <div class="form-group col-xl-4 col-md-6 col-12">
            <label for="education_subject">{{ "EDUCATION_SUBJECT" | translate }}</label>
            <input *ngIf="selectedEducationName !== 'Laurea'" type="text" id="education_subject" class="form-control" [formControlName]="'education_subject'" />
            <ng-select
              *ngIf="selectedEducationName === 'Laurea'"
              bindValue="id"
              bindLabel="name"
              id="education_title1"
              [formControlName]="'education_subject'"
              [items]="_educationSubjectService.list"
              [closeOnSelect]="true"
              [clearable]="false"
              [openOnEnter]="false"
              [virtualScroll]="true"
            >
            </ng-select>
          </div>
          <div class="form-group col-xl-4 col-md-6 col-12">
            <label [for]="'education_vote'">{{ "EDUCATION_VOTE" | translate }}</label>
            <input type="text" [id]="'education_vote'" [formControlName]="'education_vote'" class="form-control {{ fieldHasErrors('education_vote') ? 'is-invalid' : '' }}" />
            <div class="invalid-feedback">{{ "ERRORS.INSERT_VOTE" | translate }}</div>
          </div>
          <div class="form-group col-12">
            <label for="certifications">{{ "CERTIFICATIONS" | translate }}</label>
            <ng-select
              bindValue="id"
              bindLabel="name"
              id="certifications"
              [formControlName]="'certifications'"
              [multiple]="true"
              [items]="_certificationService.list_enabled"
              [closeOnSelect]="true"
              [clearable]="false"
              [openOnEnter]="false"
              [virtualScroll]="true"
            >
            </ng-select>
            <div class="form-group col-12 mt-025 mb-0 pl-0">
              <p class="sugges-new-item" (click)="modalOpen(modalAddNewCertifications, null)">{{ "MODAL.NOT_CERTIFICATE_CANDIDATE" | translate }}</p>
            </div>
            <div class="form-group col-12 pl-0 mb-0" *ngIf="items_certifications && items_certifications.length > 0">
              {{ "CERTIFICATION_TO_APPROVE" | translate }}: <span *ngFor="let item of items_certifications" class="badge badge-secondary ml-1">{{ item.name || item.id }}</span>
            </div>
          </div>
        </section>
      </div>
      <!-- skills -->
      <div class="card" id="skill-section" [ngClass]="activeTab === 'skill' ? 'active' : ''">
        <div class="card-title px-2 mb-0" (click)="changeTab('skill')">
          <h4 class="mb-0">{{ "SKILLS" | translate }}</h4>
        </div>
        <section [ngClass]="activeTab === 'skill' ? 'card-body' : ''">
          <div [ngClass.xl]="'mt-1 d-flex'" *ngFor="let item of items_skills; let i = index" [ngClass]="items_skills.length != i + 1 ? 'pb-2 mb-2 border-bottom' : ''">
            <div [ngClass.xl]="'form-group flex-basis-30 pr-1'">
              <label [for]="'skill_' + i">{{ "SKILLS" | translate }}<sup class="text-danger">*</sup></label>
              <div *ngIf="!item.isNew">
                <ng-select
                  [id]="'skill_' + i"
                  bindLabel="name"
                  bindValue="id"
                  [closeOnSelect]="true"
                  [(ngModel)]="item.skill"
                  (change)="checkIfAlreadyInsertedSkill($event, i)"
                  [openOnEnter]="false"
                  [virtualScroll]="true"
                  [clearable]="false"
                  [items]="_skillService.list_enabled"
                  *ngIf="item.enabled == 1; else disabledSelect"
                  class="{{ !item.skill ? 'is-invalid' : '' }}"
                >
                </ng-select>
                <ng-template #disabledSelect>
                  <ng-select [id]="'skill_' + i" bindLabel="name" bindValue="id" [(ngModel)]="item.skill" [items]="_skillService.list" [readonly]="true" [ngbTooltip]="'TO_APPROVED' | translate"></ng-select>
                </ng-template>
              </div>
              <div class="text-danger font-error" *ngIf="!item.skill">{{ "ERRORS.FIELD_SKILLS" | translate }}</div>

              <div class="form-group col-12 pl-0" *ngIf="item.enabled == 1 && !item.skill">
                <p class="sugges-new-item" (click)="modalOpen(modalAddSkill, i)">{{ "MODAL.NOT_SKILL_CANDIDATE" | translate }}</p>
              </div>
              <input type="text" class="form-control" [value]="item.skill" readonly *ngIf="item.isNew" />
            </div>
            <div [ngClass.xl]="'form-group flex-basis-30 px-1'" [ngClass.sm]="'mt-1'" [ngClass.md]="'mt-1'">
              <label [for]="'level_' + i">{{ "SENIORITY" | translate }}<sup class="text-danger">*</sup></label>
              <ng-select [id]="'level_' + i" [closeOnSelect]="true" [clearable]="false" [openOnEnter]="false" [virtualScroll]="true" class="{{ !item.level ? 'is-invalid' : '' }}" [(ngModel)]="item.level">
                <ng-option value="junior">{{ "JUNIOR" | translate }}</ng-option>
                <ng-option value="middle">{{ "MIDDLE" | translate }}</ng-option>
                <ng-option value="senior">{{ "SENIOR" | translate }}</ng-option>
              </ng-select>
              <div class="text-danger font-error" *ngIf="!item.level">{{ "ERRORS.FIELD_SENIORITY" | translate }}</div>
            </div>
            <div [ngClass.xl]="'form-group flex-basis-20 px-1 mt-05'">
              <div class="custom-control custom-control-success custom-switch mt-2">
                <span class="mr-2">{{ "SET_AS_PRIMARY_SKILL" | translate }}</span>
                <input type="checkbox" checked class="custom-control-input" [disabled]="item.level === '' || item.skill < 1" [id]="'skill_primary_' + i" [(ngModel)]="item.primary" (change)="onSetPrimarySkill(item, i)" />
                <label class="custom-control-label" [for]="'skill_primary_' + i"></label>
              </div>
            </div>
            <div [ngClass.xl]="'form-group flex-basis-20 px-1 mt-05 text-right'" class="text-right">
              <button (click)="addSkillItem()" type="button" class="btn btn-outline-success btn-circle btn-sm mt-2" rippleEffect>
                <i class="fa fa-plus text-success mt-025"></i>
              </button>
              <button *ngIf="items_skills.length > 1" (click)="deleteSkillItem(i)" type="button" class="btn btn-outline-danger btn-circle btn-sm mt-2 ml-2" rippleEffect>
                <i class="fa fa-minus text-danger mt-025"></i>
              </button>
            </div>
          </div>
        </section>
      </div>
      <!-- lingue -->
      <div class="card" [ngClass]="activeTab === 'languages' ? 'active' : ''">
        <div class="card-title px-2 mb-0" (click)="changeTab('languages')">
          <h4 class="mb-0">{{ "LANGUAGES" | translate }}</h4>
        </div>
        <section [ngClass]="activeTab === 'languages' ? 'card-body' : ''">
          <div [ngClass.xl]="'mt-1 d-flex'" *ngFor="let item of items_languages; let i = index" [ngClass]="items_languages.length != i + 1 ? 'pb-2 mb-2 border-bottom' : ''">
            <div [ngClass.xl]="'form-group flex-basis-30 pr-1'" [ngClass.md]="'form-group'">
              <label [for]="'name_' + i">{{ "LANGUAGE" | translate }}</label>
              <ng-select [id]="'name_' + i" [(ngModel)]="item.name" [searchable]="true" [closeOnSelect]="true" [clearable]="false" [openOnEnter]="false" [virtualScroll]="true">
                <ng-option *ngFor="let language of languages_list" [value]="language">{{ language }}</ng-option>
              </ng-select>
            </div>
            <div [ngClass.xl]="'form-group flex-basis-30 px-1'" [ngClass.md]="'form-group'" [ngClass.sm]="'my-1'">
              <label [for]="'speak_' + i">{{ "LEVEL_SPEAK" | translate }}</label>
              <ng-select [id]="'speak_' + i" [(ngModel)]="item.speak" [searchable]="false" [closeOnSelect]="true" [clearable]="false" [openOnEnter]="false" [virtualScroll]="true">
                <ng-template ng-label-tmp let-item="item" *ngIf="item.speak">
                  <span>{{ item }} - {{ "LANGUAGE_LEVELS." + item + ".LABEL" | translate }}</span>
                </ng-template>
                <ng-option *ngFor="let level of language_levels" [value]="level">
                  <strong>{{ level }} - {{ "LANGUAGE_LEVELS." + level + ".LABEL" | translate }}</strong>
                  <p class="white-space-break">{{ "LANGUAGE_LEVELS." + level + ".DESCRIPTION" | translate }}</p>
                </ng-option>
              </ng-select>
            </div>
            <div [ngClass.xl]="'form-group flex-basis-30 px-1'" [ngClass.md]="'form-group'">
              <label [for]="'write_' + i">{{ "LEVEL_WRITE" | translate }}</label>
              <ng-select [id]="'write_' + i" [(ngModel)]="item.write" [searchable]="false" [closeOnSelect]="true" [clearable]="false" [openOnEnter]="false" [virtualScroll]="true">
                <ng-template ng-label-tmp let-item="item" *ngIf="item.write">
                  <span>{{ item }} - {{ "LANGUAGE_LEVELS." + item + ".LABEL" | translate }}</span>
                </ng-template>
                <ng-option *ngFor="let level of language_levels" [value]="level">
                  <strong>{{ level }} - {{ "LANGUAGE_LEVELS." + level + ".LABEL" | translate }}</strong>
                  <p class="white-space-break">{{ "LANGUAGE_LEVELS." + level + ".DESCRIPTION" | translate }}</p>
                </ng-option>
              </ng-select>
            </div>
            <div [ngClass.xl]="'form-group flex-basis-10 px-1 mt-05'" class="text-right">
              <button (click)="addLanguageItem()" type="button" class="btn btn-outline-success btn-circle btn-sm mt-2" rippleEffect>
                <i class="fa fa-plus text-success mt-025"></i>
              </button>
              <button *ngIf="items_languages.length > 1" (click)="deleteLanguageItem(i)" type="button" class="btn btn-outline-danger btn-circle btn-sm mt-2 ml-2" rippleEffect>
                <i class="fa fa-minus text-danger mt-025"></i>
              </button>
            </div>
          </div>
        </section>
      </div>
      <!-- Richieste -->
      <div class="card" [ngClass]="activeTab === 'requests' ? 'active' : ''" *ngIf="isEditCandidate">
        <div class="card-title px-2 mb-0" (click)="changeTab('requests'); openTimeLine = false">
          <h4 class="mb-0">{{ "MENU.REQUEST" | translate }}</h4>
        </div>
        <section [ngClass]="activeTab === 'requests' ? 'card-body' : ''">
          <div class="row pl-1" *ngIf="candidateRequests && candidateRequests.length > 0">
            <div class="col-12 pl-0" *ngFor="let request of candidateRequests; let i = index">
              <div class="d-flex align-items-center justify-content-between border-left-3 {{ i + 1 == candidateRequests.length ? '' : 'mb-2' }} border-left-{{ request.steps[0].color_step }} pl-2">
                <div class="d-flex flex-basis-80 cursor-pointer" (click)="selectedTimeLine = selectedTimeLine === request.request.id ? null : request.request.id">
                  <div class="mr-3 flex-basis-50">
                    <div class="font-small-4">{{ "REQUEST" | translate }}:</div>
                    <div class="font-medium-1">{{ request.request_name }}</div>
                  </div>
                  <div class="mr-3">
                    <div class="font-small-4">{{ "STATE" | translate }}:</div>
                    <div class="font-medium-1">{{ request.steps[0].label_step | translate }}</div>
                  </div>
                </div>
                <div>
                  <a routerLink="/dashboard/detail-request/{{ request.request.id }}" target="_blank" class="btn btn-outline-primary mr-3">{{ "VIEW_REQUEST" | translate }}</a>
                </div>
              </div>
              <div class="col-12 mt-4 pl-0" *ngIf="selectedTimeLine === request.request.id">
                <h3>{{ "HISTORICAL" | translate }} {{ "REQUEST" | translate | lowercase }}</h3>
                <ul class="timeline my-2">
                  <li class="timeline-item" *ngFor="let step of request.steps">
                    <span class="timeline-point timeline-point-{{ step.color_step }} timeline-point-indicator"></span>
                    <div class="timeline-event">
                      <div class="d-flex justify-content-between flex-sm-row flex-column mb-sm-0 mb-1">
                        <div class="col-xl-6 col-md-6 col-12">
                          <h6>{{ step.label_step | translate}} {{ step.date ? ("IN_DATE" | translate) + " " + (step.date | date: "dd/MM/YYYY HH:mm") : null }}</h6>
                          <p *ngIf="step.note" [innerHTML]="step.note"></p>
                        </div>
                        <div class="col-xl-6 col-md-6 col-12 text-right">
                          <div class="timeline-event-time">{{ "INSERTED_BY" | translate }} {{ step.creator_name }}</div>
                          <div class="timeline-event-time">{{ "THE_MASCULIN" | translate }} {{ step.insert_date | date: "dd/MM/YYYY HH:mm" }}</div>
                        </div>
                      </div>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <!--No results for requests-->
          <div class="row" *ngIf="candidateRequests && candidateRequests.length < 1">
            <div class="col-xl-4 col-md-6 col-12">
              {{ "CANDIDATE_HAS_NO_REQUESTS" | translate }}
            </div>
          </div>
          <!--/No results for requests-->
        </section>
      </div>
      <!-- /Richieste -->
      <div class="card" *ngIf="currentUser">
        <div class="card-title px-2 mb-0" *ngIf="currentUser" (click)="changeTab('matched_requests'); openTimeLine = false">
          <h4 class="mb-0">{{ "MATCH_REQUEST" | translate }}</h4>
        </div>
        <section [ngClass]="(activeTab === 'matched_requests' ? 'card-body' : '') + ' ' + (currentUser && currentUser.request_match ? 'px-0 py-0' : '')">
          <div class="row align-items-center" *ngIf="!requestMatchingLoading && !currentUser.request_match; else matchingRequestsList">
            <div class="col-xl-8 col-md-6 col-12">{{ "LOAD_CANDIDATE_MATCHED_REQUESTS" | translate }}</div>
            <div class="col-xl-4 col-md-6 col-12 text-right">
              <button class="btn btn-primary" (click)="getMatchedRequests()">{{ "LOAD" | translate }}</button>
            </div>
          </div>
          <div *ngIf="requestMatchingLoading" class="d-flex align-items-center">
            <span [data-feather]="'loader'" [class]="'spinner'" size="16" class="mr-025"></span>
            {{ "LOADING_DATA" | translate }}
          </div>
          <ng-template #matchingRequestsList>
            <div *ngIf="currentUser.request_match < 1" class="px-2 py-2">{{ "NO_MATCHED_REQUESTS" | translate }}</div>
            <ngx-datatable
              class="bootstrap core-bootstrap mt-2 px-0 pb-0"
              columnMode="force"
              *ngIf="currentUser.request_match && currentUser.request_match.length > 0"
              [headerHeight]="30"
              [messages]="{ emptyMessage: ('NO_DATA_TO_DISPLAY' | translate) }"
              [scrollbarH]="true"
              [rowHeight]="70"
              [limit]="15"
              [footerHeight]="60"
              [rows]="currentUser.request_match"
              [sorts]="[{ prop: 'points', dir: 'desc' }]"
            >
              <ngx-datatable-column name="{{ 'NAME' | translate }}" prop="request_name" [sortable]="true" [width]="300">
                <ng-template ngx-datatable-cell-template let-row="row">
                  <a [routerLink]="'/dashboard/detail-request/' + row.id" target="_blank">{{ row.request_name }}</a>
                </ng-template>
              </ngx-datatable-column>
              <ngx-datatable-column name="{{ 'AFFINITY' | translate }}" prop="points" width="150" [sortable]="true">
                <ng-template ngx-datatable-cell-template let-row="row">
                  <div class="progress position-relative">
                    <div class="progress-percentage-colored">{{ row.points }}%</div>
                    <div class="progress-percentage-white" [style]="'clip-path: polygon(0 0, ' + row.points + '% 0%, ' + row.points + '% 100%, 0% 100%);'">
                      {{ row.points }}
                      %
                    </div>
                    <div class="progress-bar" role="progressbar" aria-value="{{row.points}}" aria-valuemin="0" aria-valuemax="100" [style]="'width: ' + row.points + '%'"></div>
                  </div>
                </ng-template>
              </ngx-datatable-column>
              <ngx-datatable-column name="{{ 'RATE' | translate }}" prop="rate" [sortable]="true">
                <ng-template ngx-datatable-cell-template let-row="row">
                  <span>{{ row.rate ? (row.rate | currency: "EUR") : "FIELD_NOT_SPECIFIED" | translate }}</span>
                </ng-template>
              </ngx-datatable-column>
              <ngx-datatable-column name="{{ 'INSERT_DATE' | translate }}" prop="date" [sortable]="true" [width]="80">
                <ng-template ngx-datatable-cell-template let-row="row">
                  <span>{{ row.date | date: "dd/MM/yyyy" }}</span>
                </ng-template>
              </ngx-datatable-column>
              <ngx-datatable-column name="{{ 'ACTIONS' | translate }}" [sortable]="false" [width]="80">
                <ng-template ngx-datatable-cell-template let-row="row">
                  <button has_capability="request_set_as_suitable" *ngIf="!row.closed" class="btn btn-outline-primary w-150" rippleEffect (click)="setCandidateToSuitable(row.id)">
                    {{ "REQUEST_STEPS.SUITABLE" | translate }}
                  </button>
                </ng-template>
              </ngx-datatable-column>
            </ngx-datatable>
          </ng-template>
        </section>
      </div>
      <!-- note -->
      <div class="card" [ngClass]="activeTab === 'notes' ? 'active' : ''">
        <div class="card-title px-2 mb-0" (click)="changeTab('notes')">
          <h4 class="mb-0">{{ "NOTES" | translate }}</h4>
        </div>
        <section [ngClass]="activeTab === 'notes' ? 'card-body' : ''">
          <div id="list-notes" *ngIf="currentUser && currentUser.notes && currentUser.notes.length > 0 && !isEditingNote">
            <div class="note" *ngFor="let note of currentUser.notes; let index = index">
              <header class="note-header">
                <div>
                  {{ note.create_date | date: "dd/MM/yyyy" }} -
                  <strong>{{ note.create_by_complete_name }}</strong>
                </div>
                <div has_capability="manage_candidate_note">
                  <button class="bg-transparent border-0 text-primary remove-item mr-05" type="button" (click)="enterEditModeNote(note, index)">
                    <i [data-feather]="'edit-2'" size="19"></i>
                  </button>
                  <button class="bg-transparent border-0 text-danger remove-item" type="button" (click)="deleteNote(note.id)">
                    <i [data-feather]="'trash-2'" size="19"></i>
                  </button>
                </div>
              </header>
              <div class="note-content" [innerHTML]="note.note"></div>
            </div>
          </div>
          <div class="mt-1 form-group" [formGroup]="formGroup">
            <label for="note">{{ "LABEL_ADD_NOTE" | translate }}</label>
            <textarea id="note" class="form-control" [formControlName]="'note'"></textarea>
          </div>
          <div class="d-flex justify-content-end" has_capability="manage_candidate_note" *ngIf="isEditingNote">
            <button class="btn btn-primary text-primary mb-4" (click)="saveNote()">{{ "EDIT" | translate }}</button>
          </div>
        </section>
      </div>
      <div class="text-right">
        <button [disabled]="isSubmitting" class="btn btn-primary text-primary mb-4" (click)="save()">{{ (currentUser ? "EDIT" : "SAVE") | translate }}</button>
      </div>
    </div>
  </div>
</div>

<!-- Modal New Skill -->
<ng-template #modalAddSkill let-modal>
  <form (ngSubmit)="addModalObjectSkill(); modal.close()">
    <div class="modal-header">
      <div></div>
      <button type="button" class="close" (click)="modal.dismiss('Cross click')" aria-label="Close">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
    <div class="modal-body" tabindex="0">
      <h3>{{ "MODAL.NOT_SKILL_CANDIDATE" | translate }}</h3>
      <p>{{ "MODAL.INSERT_HERE" | translate }}</p>
      <label [for]="'new_skill'">{{ "SKILLS" | translate }}<sup class="text-danger">*</sup></label>
      <input name="new_skill" [(ngModel)]="new_skill" type="text" [id]="'new_skill'" class="form-control" />
    </div>
    <div class="modal-footer d-flex justify-content-center">
      <button type="submit" class="btn btn-primary w-150" rippleEffect>{{ "SEND" | translate }}</button>
    </div>
  </form>
</ng-template>
<!-- / Modal New Skill -->

<!-- Modal New Certifications-->
<ng-template #modalAddNewCertifications let-modal>
  <form (ngSubmit)="addModalObjectCertification(); modal.close()">
    <div class="modal-header">
      <div></div>
      <button type="button" class="close" (click)="modal.dismiss('Cross click')" aria-label="Close">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
    <div class="modal-body" tabindex="0">
      <h3>{{ "MODAL.NOT_CERTIFICATE_CANDIDATE" | translate }}</h3>
      <p>{{ "MODAL.INSERT_HERE" | translate }}</p>
      <label [for]="'new_certificate'">{{ "CERTIFICATE" | translate }}</label>
      <input name="new_certificate" [(ngModel)]="new_certificate" type="text" [id]="new_certificate" class="form-control" />
    </div>
    <div class="modal-footer d-flex justify-content-center">
      <button type="submit" class="btn btn-primary w-150" rippleEffect>
        {{ "SEND" | translate }}
      </button>
    </div>
  </form>
</ng-template>
<!-- / Modal New Certifications -->
